export const logo_yellow = require('./logo_jaune.png');
